/* TRAVA - Buton WhatsApp pe pagina produsului de prezentare */
(function () {
  var PHONE = '40772285975';


  function init() {
    var info = document.querySelector('.product__info-container');
    if (!info || info.querySelector('.mireasa-wa')) return;

    var h1 = info.querySelector('.product__title h1') || document.querySelector('h1');
    var name = h1 ? h1.textContent.trim() : document.title;
    var url = window.location.href.split('?')[0];
    var msg = 'Bună! Aș dori să comand: ' + name + ' - ' + url;

    var btn = document.createElement('a');
    btn.className = 'mireasa-wa';
    btn.href = 'https://wa.me/' + PHONE + '?text=' + encodeURIComponent(msg);
    btn.target = '_blank';
    btn.rel = 'noopener';
    btn.textContent = 'Personalizează-ți buchetul';

    var desc = info.querySelector('.product__description');
    if (desc && desc.parentNode) {
      desc.parentNode.insertBefore(btn, desc.nextSibling);
    } else {
      info.appendChild(btn);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();